import floorIcon from "../../../icons/floor.svg";
import undergroundIcon from "../../../icons/underground.svg";
import roofIcon from "../../../icons/roof.svg";

export type FloorType = "ROOF" | "FLOOR" | "UNDERGROUND";

export class FloorItemModel {
  constructor(
    public id: string,
    public name: string,
    public type: FloorType,
    public numberOfAnnotations: number,
    public isGraphic: boolean
    ) {}

  get icon(): string {
    return {
      ROOF: roofIcon,
      FLOOR: floorIcon,
      UNDERGROUND: undergroundIcon,
    }[this.type];
  }
}
